export const adminlogin = [{
    background : "./Images/admin-login/background.jpg",
    logo:"./Images/admin-login/Trustline_Digital_Logo_black.png"
}]